import React, { useContext } from 'react';
import StyledContainer from './StyledContainer';
import StylesContext from '../context/StylesContext';
import StyledTitle from './StyledTitle';
import { useNavigate } from 'react-router-dom';
import { categoryItemsPath } from '../helpers/menuRoutes';

interface CategoriesCardProps {
  categorieElement: string;
  categorieImage?: string | null;
  isButton: boolean;
  // destino do clique; quando ausente, cai na rota de itens da categoria.
  // subcategorias e o atalho "ver todos" passam a rota que precisam
  to?: string;
};

const CategoriesCard: React.FC<CategoriesCardProps> = ({ categorieElement, categorieImage, isButton, to }) => {
  const { styles } = useContext(StylesContext);
  const history= useNavigate();
  const handleClick = () => {
    if (isButton) {
      history(to || categoryItemsPath(styles.urlId, categorieElement));
    }
  };

  return (
    <StyledContainer
      $bgColor={styles.bgCategoryContainer}
      className='categories_card'
      onClick={handleClick}
    >
      {
        <>
          {
            // imagem é opcional em subcategorias, então o espaço é mantido vazio
            // para os nomes continuarem alinhados entre os cards
            categorieImage
              ? <img className='category_img' src={ categorieImage } alt='Imagem de categoria de alimento'/>
              : <StyledContainer className='category_img category_img_placeholder' />
          }
          <StyledTitle className='text_category_name' $textColor={styles.textColor}>{categorieElement}</StyledTitle>
        </>
      }
    </StyledContainer>
  )
}

export default CategoriesCard;
